/* eslint-disable max-len */
import Image from "next/image";
import Link from "next/link";

import PartnersAndSponsorsLinks from "@/features/partnerAndSponsors/PartnersAndSponsorsLinks";
import { ROUTES } from "@/helpers/routes";
import PageSeo from "@/shared/components/PageSeo";

import Layout from "../../shared/components/layout";

export default function HeadlinePartners() {
    return (
        <div>
            <PageSeo title="Headline Partners | The Gender Index" pathname={ROUTES.headlinePartners} />
            <Layout>
                <div className='singleLayout type2 partnersPage'>
                    <h3>Partners and sponsors</h3>
                    <p className='body-default-copy-large'>Thank you to our partners and sponsors who make it possible for The Gender Index to exist, click on the logos below to learn more about why they are supporting The Gender Index.</p>
                    <PartnersAndSponsorsLinks />
                    <div className='partnerBanner type2'>
                        <div className="container">
                            <div className="grid-wrapper">
                                <div className="row justify-content-center">
                                    {/* <div className="col-12 col-lg-4">
                                        <figure>
                                            <Image
                                                src="/images/PartnerLogos/hsbc.png"
                                                alt="logo_image"
                                                width={250}
                                                height={150}
                                                loading="lazy"
                                            />
                                        </figure>
                                        <p className='body-default-copy threeLinerText textCenter'>As a committed, long-term partner to the innovation economy, we offer more than commercial banking services. We have
                                            the expertise, agility and connections that high-growth technology, private equity, and venture capital businesses need to
                                            accelerate.</p>
                                        <Link href="/headline-partners/hsbc"><button className="btn-red-outlined btn-reset">Read More</button></Link>
                                    </div> */}
                                    <div className="col-12 col-lg-4">
                                        <figure>
                                            <Image
                                                src="/images/PartnerLogos/mnai.png"
                                                alt="logo_image"
                                                width={250}
                                                height={150}
                                                loading="lazy"
                                            />
                                        </figure>
                                        <p className='body-default-copy threeLinerText textCenter'>mnAi, a distinguished multi-award-winning data, insight, and analytics platform, leverages proprietary technology to
                                            deliver advanced research, analytics, and due diligence services for all UK companies. With an expansive dataset
                                            comprising 12 billion+ data points covering over 11 million UK companies, mnAi has earned the trust of clients relying
                                            on its capability to protect, strengthen and elevate their business operations. We believe that data technology can
                                            empower rapid change and are proud to work with leading organisations who share these values.</p>
                                        <Link href="/headline-partners/mnai"><button className="btn-red-outlined btn-reset">Read More</button></Link>
                                    </div>
                                    {/* <div className="col-12 col-lg-4">
                                        <figure>
                                            <Image
                                                src="/images/PartnerLogos/natwest-new.png"
                                                alt="logo_image"
                                                width={250}
                                                height={150}
                                                loading="lazy"
                                            />
                                        </figure>
                                        <p className='body-default-copy threeLinerText textCenter'>NatWest Group is a relationship bank for a digital world. We champion potential; breaking down barriers and building
                                            financial confidence so the 19 million people, families and businesses we serve in communities throughout the UK and
                                            Ireland can rebuild and thrive. If our customers succeed, so will we.</p>
                                        <Link href="/headline-partners/natwest/"><button className="btn-red-outlined btn-reset">Read More</button></Link>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </Layout>
        </div>
    );
}

